import { render, staticRenderFns } from "./RiskIndicators.vue?vue&type=template&id=17c8d64e"
import script from "./RiskIndicators.vue?vue&type=script&lang=js"
export * from "./RiskIndicators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports